<template>
  <div class="wrapper">
    <!-- 有权限 -->
    <template v-if="is_auth">
      <!-- 页面头部 -->
      <div class="page-header">
        <div class="header-content">
          <h2 class="page-title">
            <i class="el-icon-data-line title-icon"></i>
            <span>数据概览</span>
          </h2>
          <div class="header-date">
            <i class="el-icon-calendar"></i>
            <span>{{ new Date().toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
          </div>
        </div>
      </div>

      <!-- 数据概览 -->
      <div class="overview-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card class="overview-card income-card" shadow="never">
              <template #header>
                <div class="card-header">
                  <div class="header-left">
                    <i class="el-icon-money icon income"></i>
                    <span>今日收入</span>
                  </div>
                  <span class="header-value">￥{{ statResult.incomeData?.dayTotalFee || '0.00' }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>正常租金</span>
                  <span>￥{{ statResult.incomeData?.dayNormalBillFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>逾期租金</span>
                  <span>￥{{ statResult.incomeData?.dayOverdueBillFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>其他收入</span>
                  <span>￥{{ statResult.incomeData?.dayOtherFee }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计收入</span>
                <span>￥{{ statResult.incomeData?.yearTotalFee }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="overview-card expense-card" shadow="never">
              <template #header>
                <div class="card-header">
                  <div class="header-left">
                    <i class="el-icon-shopping-cart-2 icon expense"></i>
                    <span>今日支出</span>
                  </div>
                  <span class="header-value">￥{{ statResult.expenseData?.dayTotalFee || '0.00' }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>采购成本</span>
                  <span>￥{{ statResult.expenseData?.dayTotalFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>其他支出</span>
                  <span>￥{{ statResult.expenseData?.dayOtherFee }}</span>
                </p>
                <p class="card-content-item"></p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计支出</span>
                <span>￥{{ statResult.expenseData?.yearTotalFee }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="overview-card order-card" shadow="never">
              <template #header>
                <div class="card-header">
                  <div class="header-left">
                    <i class="el-icon-tickets icon order"></i>
                    <span>今日订单</span>
                  </div>
                  <span class="header-value">{{ statResult.orderData?.dayCreateNum || 0 }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>成单数量</span>
                  <span>{{ statResult.orderData?.dayDealNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>成单转化率</span>
                  <span>{{ statResult.orderData?.dayDealRate || '-' }}%</span>
                </p>
                <p class="card-content-item">
                  <span>当前逾期</span>
                  <span>{{ statResult.orderData?.totalOverdueNum }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计成单</span>
                <span>{{ statResult.orderData?.yearDealNum }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="overview-card store-card" shadow="never">
              <template #header>
                <div class="card-header">
                  <div class="header-left">
                    <i class="el-icon-office-building icon store"></i>
                    <span>门店总数</span>
                  </div>
                  <span class="header-value">{{ statResult.storeData?.totalNum || 0 }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>今日新增</span>
                  <span>{{ statResult.storeData?.dayIncrNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>今日成单</span>
                  <span>{{ statResult.storeData?.dayDealNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>当前逾期</span>
                  <span>{{ statResult.storeData?.totalOverdueNum }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本月累计新增</span>
                <span>{{ statResult.storeData?.monthIncrNum }}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 图表展示 -->
      <div class="chart-box">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <i class="el-icon-data-analysis"></i>
            <span>下单/成单统计</span>
          </div>
          <div class="chart-item">
            <LineChart
                v-if="show"
                title="下单/成单统计"
                :list_x="statResult.orderChartLine?.xaxis || []"
                series_name="下单数量"
                :list_y="statResult.orderChartLine?.yaxis || []"
                series_name2="成单数量"
                :list_y2="statResult.orderChartLine?.yaxis2 || []"
                dataType="number"
            ></LineChart>
          </div>
        </el-card>
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <i class="el-icon-pie-chart"></i>
            <span>账单缴纳率统计</span>
          </div>
          <div class="chart-item">
            <LineChart
                v-if="show"
                :list_x="statResult.billPayRateChartLine?.xaxis || []"
                series_name="缴纳率"
                :list_y="statResult.billPayRateChartLine?.yaxis || []"
                title="账单缴纳率统计"
                dataType="percent"
            ></LineChart>
          </div>
        </el-card>
      </div>

      <!-- 排行榜 -->
      <div class="rank-box">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="rank-card" shadow="never">
              <template #header>
                <div class="rank-header">
                  <i class="el-icon-trophy"></i>
                  <span>门店成交金额排行榜</span>
                </div>
              </template>
              <div class="rank-content">
                <div class="rank-content-item" v-for="(item, i) in statResult.storeRankList" :key="i">
                  <div class="col1">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="col2">
                    <div class="name">{{ item.storeName }}</div>
                    <div class="num">开店时间：{{ item.createTime }}</div>
                  </div>
                  <div class="col3">订单数：{{ item.orderDealNum }}</div>
                  <div class="col4">订单金额：￥{{ item.orderDealAmount }}</div>
                </div>
                <el-empty v-if="!statResult.storeRankList || statResult.storeRankList.length == 0" description="暂无数据"></el-empty>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="rank-card" shadow="never">
              <template #header>
                <div class="rank-header">
                  <i class="el-icon-trophy"></i>
                  <span>产品成交数量排行榜</span>
                </div>
              </template>
              <div class="rank-content">
                <div class="rank-content-item" v-for="(item, i) in statResult.goodsRankList" :key="i">
                  <div class="col1">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="col2">
                    <div class="name">{{ item.goodsName }}</div>
                  </div>
                  <div class="col3">订单数：{{ item.orderDealNum }}</div>
                  <div class="col4">订单金额：￥{{ item.orderDealAmount }}</div>
                </div>
                <el-empty v-if="!statResult.goodsRankList || statResult.goodsRankList.length == 0" description="暂无数据"></el-empty>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </template>
    <!-- 无权限 -->
    <template v-else>
      <el-empty description="敬请期待"></el-empty>
    </template>
  </div>
</template>

<script>
import { getHomeStatAPI } from './api';
import LineChart from './LineChart/LineCharts.vue';

export default {
  name: 'Home',
  components: { LineChart },
  data() {
    return {
      show: false,
      current_date: 1,
      statResult: {},
    }
  },
  computed: {
    is_auth() {
      const authMenus = this.$store.state.user.authMenus;
      const is_admin = this.$store.state.user.isAdmin;
      const res = authMenus.indexOf('Home');
      return is_admin == 1 || res > -1;
    },
    today() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 0);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
    today1() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 1);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
    today2() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 2);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
  },
  mounted() {
    this.getHomeStat();
  },
  filters: {
    todayName(val) {
      let arr = val.split('-');
      return arr[1] + '月' + arr[2] + '日';
    }
  },
  methods: {
    async getHomeStat() {
      if (!this.is_auth) return;
      this.statResult = await getHomeStatAPI();
      this.show = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-date {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #909399;
    
    i {
      font-size: 16px;
      color: #409EFF;
    }
  }
}

::v-deep .el-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  
  .el-card__header {
    padding: 16px 24px;
  }

  .el-card__body {
    padding: 0;
  }
}

.overview-box {
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  font-size: 14px;
  line-height: 22px;

  .overview-card {
    height: 260px;
    display: flex;
    flex-direction: column;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 1;
    }
    
    &.income-card::before {
      background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
    }
    
    &.expense-card::before {
      background: linear-gradient(90deg, #F56C6C 0%, #f78989 50%, #f89a9a 100%);
    }
    
    &.order-card::before {
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }
    
    &.store-card::before {
      background: linear-gradient(90deg, #E6A23C 0%, #ebb563 50%, #f0c27a 100%);
    }
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    position: relative;
    z-index: 1;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .header-value {
    font-size: 26px;
    font-weight: 700;
    color: #303133;
    letter-spacing: -0.5px;
  }

  .icon {
    font-size: 20px;
    border-radius: 10px;
    padding: 10px;
    transition: all 0.3s ease;
  }

  .icon.income {
    color: #67C23A;
    background: linear-gradient(135deg, #F0FAF3 0%, #e8f5ed 100%);
    box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2);
  }

  .icon.expense {
    color: #F56C6C;
    background: linear-gradient(135deg, #FFF4F4 0%, #ffe8e8 100%);
    box-shadow: 0 2px 8px rgba(245, 108, 108, 0.2);
  }

  .icon.order {
    color: #409EFF;
    background: linear-gradient(135deg, #F2F8FF 0%, #e6f2ff 100%);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .icon.store {
    color: #E6A23C;
    background: linear-gradient(135deg, #FFF7E6 0%, #fff0d1 100%);
    box-shadow: 0 2px 8px rgba(230, 162, 60, 0.2);
  }

  .card-content {
    padding: 16px 24px;
    flex: 1;
  }

  .card-content-item {
    display: flex;
    justify-content: space-between;
    min-height: 28px;
    padding: 8px 0;
    transition: all 0.2s ease;
    
    &:hover {
      background: rgba(64, 158, 255, 0.03);
      border-radius: 6px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .card-content-item span:first-child {
    color: #606266;
    font-size: 14px;
  }

  .card-content-item span:last-child {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
  }

  .card-divider {
    border-top: 1px solid #EBEEF5;
    margin: 0 24px;
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    padding: 14px 24px;
    background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
    font-size: 13px;
    
    span:first-child {
      color: #909399;
    }
    
    span:last-child {
      font-weight: 600;
      color: #303133;
      font-size: 15px;
    }
  }
}

.chart-box {
  margin-bottom: 24px;
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 1;

  .chart-card {
    flex: 1;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }
    
    .chart-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        color: #409EFF;
      }
    }
    
    .chart-item {
      height: 360px;
      padding: 16px;
    }
  }
}

.rank-box {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;

  .rank-card {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    }
    
    .rank-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        color: #E6A23C;
      }
    }
  }

  .rank-content {
    min-height: 200px;
    padding: 8px 0;

    .rank-content-item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;
      padding: 14px 24px;
      transition: all 0.3s ease;
      border-radius: 8px;
      margin: 4px 8px;

      &:hover {
        background: linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
        transform: translateX(4px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      }
      
      &:last-child {
        border-bottom: none;
      }
      
      .col1 {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        width: 50px;
        justify-content: center;
        span {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border-radius: 50%;
          color: #fff;
          background-color: #C0C4CC;
          font-size: 14px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
        }
      }
      
      .col2 {
        padding: 0 12px;
        flex: 2;
        .name {
          font-size: 16px;
          font-weight: 700;
          color: #303133;
          margin-bottom: 4px;
        }
        .num {
          font-size: 13px;
          color: #909399;
        }
      }
      
      .col3 {
        padding: 0 12px;
        flex: 1;
        text-align: right;
        font-weight: 600;
        color: #606266;
        font-size: 14px;
      }
      
      .col4 {
        padding: 0 12px;
        flex: 1;
        text-align: right;
        font-weight: 700;
        color: #409EFF;
        font-size: 15px;
      }
    }
    
    .rank-content-item:nth-child(1) {
      .col1 span {
        background: linear-gradient(135deg, #F56C6C 0%, #f78989 100%);
        width: 32px;
        height: 32px;
        font-size: 16px;
        box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
      }
    }
    
    .rank-content-item:nth-child(2) {
      .col1 span {
        background: linear-gradient(135deg, #E6A23C 0%, #ebb563 100%);
        width: 30px;
        height: 30px;
        box-shadow: 0 3px 10px rgba(230, 162, 60, 0.3);
      }
    }
    
    .rank-content-item:nth-child(3) {
      .col1 span {
        background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
        width: 30px;
        height: 30px;
        box-shadow: 0 3px 10px rgba(103, 194, 58, 0.3);
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper {
    padding: 16px;
  }
  
  .overview-box {
    ::v-deep .el-col {
      margin-bottom: 16px;
    }
  }
  
  .chart-box {
    flex-direction: column;
    gap: 16px;
  }
}

@media (max-width: 1200px) {
  .overview-box {
    ::v-deep .el-col {
      width: 50%;
      flex: 0 0 50%;
    }
  }
  
  .rank-box {
    ::v-deep .el-col {
      width: 100%;
      flex: 0 0 100%;
      margin-bottom: 16px;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .page-title {
      font-size: 20px;
    }
    
    .header-date {
      font-size: 12px;
    }
  }
  
  .overview-box {
    .overview-card {
      height: auto;
      min-height: 240px;
    }
    
    .header-value {
      font-size: 22px;
    }
  }
  
  .chart-box {
    .chart-card {
      .chart-item {
        height: 300px;
      }
    }
  }
  
  .rank-box {
    .rank-content {
      .rank-content-item {
        flex-wrap: wrap;
        padding: 12px 16px;
        
        .col2,
        .col3,
        .col4 {
          flex: 1 1 100%;
          padding: 4px 0;
          text-align: left;
        }
        
        .col3,
        .col4 {
          text-align: right;
        }
      }
    }
  }
}
</style>
